import {Component, Input, OnInit} from '@angular/core';
import {map} from 'rxjs';
import {TherapistService} from '../../services/therapist.service';
import {environment} from '../../../environments/environment';
import {PlansDataService} from '../../components/plans/plans-data.service';
import {AuthService} from '../../../../../firebase/src/lib/services/auth.service';
import {PaymentComponent} from '../../components/payment/payment.component';
import {AuthComponent} from '../../components/auth/auth.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {DataService} from '../../../../../firebase/src/lib/services/data.service';
import {PromoHandlerService} from '../../../../../shared/src/lib/components/promo-handler/promo-handler.service';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';

@Component({
    selector: 'app-pricing',
    templateUrl: './pricing.component.html',
    styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {
    items: any[] = [];
    environment = environment;
    successRoute = 'cs';
    requestType: 'capture' | 'authorize' = null;
    returnUrl = 'cs';
    submitButtonText = 'Пройти тест';

    loading = false;

    activePlan = null;


    discountValue = null;

    form: FormGroup;
    error = null;
    apiUrl = environment.apiUrl;

    codeApplyed = false;
    isUpdate = false;
    promoCodeId = null;

    constructor(
        private modalService: NgbModal,
        private data: PlansDataService,
        private auth: AuthService,
        private service: TherapistService,
        private dataService: DataService,
        private promoHandler: PromoHandlerService,
        private toaster: ToastrService,
        private fb: FormBuilder
    ) {
    }

    ngOnInit(): void {
        this.form = this.fb.group({
            promoCode: [null, Validators.required]
        });
        this.form.valueChanges.subscribe(() => {
            this.codeApplyed = false;
            this.error = null;
        });
        this.getPlan()
            .subscribe((res: any) => {
                this.items = res.filter((el: any) => el.type === 'subscription')
                    .map((el: any) => {
                        if (el.frequency === 'annual') {
                            el.title = 'Отримуйте персоналізовану підтримку, інсайти на основі нейронауки та щоденні рекомендації – все в одному сервісі. Вартість передплати складе лише 134грн./місяць (оплата щорічно – 1608 грн.). Ви можете скасувати передплату будь-коли натиснувши “відписатися” на кожній сторінці сервісу.';
                        } else if (el.frequency === 'monthly') {
                            el.title = 'Отримуйте персоналізовану підтримку, інсайти на основі нейронауки та щоденні рекомендації – все в одному сервісі. Вартість передплати складе лише 268грн./місяць (оплата щомісяця). Ви можете скасувати передплату будь-коли натиснувши “відписатися” на кожній сторінці сервісу.';

                        }
                        return el;
                    });
                this.switchPlan(this.items[0]);
            });
    }

    switchPlan(plan: any) {
        this.activePlan = plan;
    }

    get isLoggedIn() {
        return this.auth.isLoggedIn;
    }

    getPlan() {
        const plansetEndpoint = 'default'; //this.service.isTherapistApp() ? 'therapist' : 'default';
        return this.data.getPlans(this.environment.apiUrl, plansetEndpoint);
    }

    // openAuthModal(): Promise<any> {
    //     const modalRef = this.modalService.open(AuthComponent, {
    //         centered: true,
    //         size: 'md',
    //         windowClass: 'modal login',
    //         backdrop: 'static',
    //         keyboard: true
    //     });
    //     modalRef.componentInstance.data = {};
    //     return modalRef.result;
    // }

    userData() {
        return new Promise((resolve, reject) => {
            this.auth.userSubscription().subscribe((docSnapshot: any) => {
                const data = docSnapshot.payload.data();
                if (data) {
                    resolve(data);
                }
            }, reject);
        });
    }

    // onPay(subscription, plan, isUpdate = false) {
    //     if (this.auth.isLoggedIn) {
    //         this.openPaymentModal(subscription, plan, isUpdate);
    //     } else {
    //         this.openAuthModal()
    //             .then((res) => {
    //                 if (res) {
    //                     this.openPaymentModal(subscription, plan, isUpdate);
    //                 }
    //             });
    //     }
    // }
    login() {
        const modalRef = this.modalService.open(AuthComponent, {
            centered: true,
            size: 'md',
            windowClass: 'modal login',
            backdrop: 'static',
            keyboard: true
        });

        modalRef.result.then((res: any) => {
            if (res) {
                // this.configPayment();
            }
        });
    }

    pay(prop) {
        // this.loading = true;
        this.data.pay(this.environment.apiUrl, prop)
            .subscribe((res: any) => {
                this.dataService.orderId = prop.type === 'subscription' ? res.subscription_id : res.order_id;
                this.dataService.orderType = prop.type;
                if (res.checkout_url) {
                    this.openLiqPayUrl(res.checkout_url);
                    this.loading = false;
                    this.promoHandler.localPromoCode = null;
                } else {
                    this.loading = false;
                    this.promoHandler.localPromoCode = null;
                }


            }, (err) => {
                this.showError(err.error?.detail);
                this.loading = false;
            });
    }

    showError(error: string) {
        switch (error) {
            case 'already-subscribed':
                return this.toaster.info('Ви вже підписані');
            default:
                return this.toaster.error('Сталася помилка. Спробуйте пізніше');
        }
    }

    openLiqPayUrl(url: string) {
        window.open(url, '_self');
    }

    // openPaymentModal(subscription, plan: any, isUpdate = false) {
    //     const modalRef = this.modalService.open(PaymentComponent, {
    //         centered: true,
    //         windowClass: 'modal payment',
    //         backdrop: 'static',
    //         keyboard: true
    //     });
    //     modalRef.componentInstance.isUpdate = isUpdate;
    //     modalRef.componentInstance.requestType = this.requestType;
    //     modalRef.componentInstance.plan = plan;
    //     modalRef.componentInstance.successRoute = this.successRoute;
    //     modalRef.componentInstance.submitButtonText = this.submitButtonText;
    //     modalRef.result.then(
    //         (res) => {
    //             if (res) {
    //                 plan.discount_id = res?.discount_id;
    //                 plan.referrer_id = this.promoHandler.localPromoCode;
    //                 this.pay(plan, subscription);
    //             }
    //         }, (err) => {
    //             console.log(err);
    //         }
    //     ).catch(err => {
    //         console.log(err);
    //     });
    // }

    applyPromo(plan: any) {
        if (!plan) {
            return;
        }
        this.loading = true;
        this.promoHandler.applyPromo({
            plan_id: plan.id,
            discount_id: this.form.get('promoCode').value
        }, this.apiUrl)
            .subscribe((res) => {
                this.promoCodeId = this.form.get('promoCode').value;
                this.codeApplyed = true;
                const data = JSON.parse(res);
                this.discountValue = (plan.value - (plan.value * data.discount)).toFixed(2);
                this.loading = false;
                this.error = null;
            }, (err) => {
                this.promoCodeId = null;
                const error = JSON.parse(err.error);
                this.loading = false;
                this.discountValue = null;
                if (error && typeof error?.detail !== 'undefined') {
                    this.error = this.translateError(error?.detail);
                }
            });
    }

    translateError(error: string) {
        switch (error) {
            case 'discount-not-found':
                return 'Такого промокода не існує';
        }
    }

}
